export default __webpack_public_path__ + "static/media/fixture1_teacher.2b0d3196.png";